// extracted by mini-css-extract-plugin
module.exports = {"Menu":"menuStyles-module--Menu--2GnSt","Item":"menuStyles-module--Item--1hal-","LinkP":"menuStyles-module--LinkP--2_BTU"};